import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import MobileNavigationBar from "../components/mobileNavbar";
import zelle from "../assets/zelle.png";
import venmo from "../assets/venmo.png";
import paypal from "../assets/paypal.png";
import madinaapps from "../assets/madinaapps.png";
import feelingblessed from "../assets/feelingblessed.png";
import checks from "../assets/checks.png";
import benevity from "../assets/benevity.png";
import ZakatChart from "../components/zakatchart";
import MobileFooter from "../components/mobileFooter";
import austincares from "../assets/austincares.png";


const paymentMethods = [
    { name: "Zelle", description: <>accountant@austinmosque.org<br/>Please specify zakat or sadaqah</>, icon: zelle, link: null },
    { name: "Venmo", description: <>@icgamanor<br/>Please specify zakat or sadaqah</>, icon: venmo, link: null },
    {
        name: "Checks",
        description: (
            <>
                Make checks out to ICGA <br />
                Mail to: 5110 Manor Rd, Austin TX 78723
            </>
        ),
        icon: checks, link: null
    },
    { name: "PayPal", description: <>Donate to Islamic Center of Greater Austin<br/>Donate to PayPal Giving Fund (no fees)</>, icon: paypal, link: "https://www.paypal.com/us/fundraiser/charity/1573815" },
    { name: "Feeling Blessed", description: "Donate via Feeling Blessed", icon: feelingblessed, link: "https://www.feelingblessed.org/donate/islamic-center-of-greater-austin-manor" },
    { name: "Madina Apps", description: "Support us through Madina Apps", icon: madinaapps, link: "https://payments.madinaapps.com/ICGA" },
    {
        name: "Company Matching (Benevity)",
        description: (
            <>
                ICGA is registered with several company matching programs.
                Please consult your HR Department for details.
                Google, Apple, Visa, Intel, etc.
            </>
        ),
        icon: benevity,
        link: "https://causes.benevity.org/user"
    },
    {
        name: "Company Matching (Austin Cares)",
        description: (
            <>
                512 Brothers & Sisters is registered with several company matching programs.
                IBM, Microsoft, Dell, etc.  <br />
                512 Brothers & Sisters <br />
                DBA: AustinCares <br />
                EI Number: 47-0996261 <br />
                11331 North Lamar BLVD Suite D2 Austin TX, 78753

            </>
        ),
        icon: austincares,
        link: "https://causes.benevity.org/user"
    },
    {
        name: "Stock Donations",
        description: (
            <>
                You can pay zakat by donating stocks through Nueces Mosque. Make sure to select Zakat in the form. 
            </>
        ),
        icon: 'https://static.tgbwidget.com/organization_logo/cffef258-bb84-455c-9590-980e70d6edae.png',
        link: "https://www.nuecesmosque.com/reconstruction#donate"

    }
];

export const MobilePayZakat = () => {
    return (
        <div className="home-page">
            <MobileNavigationBar />

            <div
                style={{
                    backgroundColor: "rgba(164, 198, 134, 0.5)",
                    padding: "20px 0",
                    textAlign: "center",
                    color: "black",
                    fontFamily: "Arial, sans-serif",
                    fontSize: "18px",
                    lineHeight: "1.6",
                }}
            >
                <div className="px-4">
                    <h1 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "10px" }}>
                        Pay Zakat Locally
                    </h1>
                    <div
                        style={{

                            borderRadius: "10px",
                            textAlign: "center"
                        }}
                    >
                        <p style={{ fontSize: '14px', marginBottom: '20px', fontWeight: '500' }}>
                            Living in Austin is expensive — please donate generously.
                            Your support helps refugees, single mothers, reverts, the elderly,
                            families with young children, and those without access to education.
                        </p>
                        <a
                            href="/HowItWorks#example-case"
                            style={{
                                display: "inline-block",
                                padding: "10px 14px",
                                backgroundColor: "#3C256B",
                                color: "white",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                textDecoration: "none",
                                fontSize: "12px"
                            }}
                        >
                            See How Much It Takes to Support a Family
                        </a>
                    </div>
                </div>
            </div>
            <Container className="my-4 px-3 text-align-center" >
                <p style={{ fontSize: "18px", fontWeight: "bold", textAlign: "center" }}>
                    إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ وَالْعَامِلِينَ عَلَيْهَا وَالْمُؤَلَّفَةِ قُلُوبُهُمْ وَفِي الرِّقَابِ وَالْغَارِمِينَ وَفِي سَبِيلِ اللَّهِ وَابْنِ السَّبِيلِ فَرِيضَةً مِّنَ اللَّهِ وَاللَّهُ عَلِيمٌ حَكِيمٌ
                    <br />
                </p>
                <div className="mx-2" style={{ textAlign: "center", marginBottom: "20px" }}>
                    <p style={{ fontSize: "14px" }}> Donate here at ICGA or give your Zakat through Austin-area masajid</p>
                </div>
                <h4 className="mb-2">Please mark your donation as Zakat or Sadaqah, JazakAllah Khair</h4>
                <Row className="g-2" >
                    {paymentMethods.map((method, index) => (
                        <Col xs={12} md={4} key={index}>
                            <div
                                className="d-flex align-items-center p-2 rounded-3 shadow-sm h-100"
                                style={{
                                    border: "3px solid #A4C686",
                                    maxWidth: "450px",
                                    margin: "auto",
                                }}
                            >
                                {method.link ? (
                                    <a href={method.link} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={method.icon}
                                            alt={method.name}
                                            className="me-2"
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "20%",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <img
                                        src={method.icon}
                                        alt={method.name}
                                        className="me-3"
                                        style={{
                                            width: "30px",
                                            height: "30px",
                                            borderRadius: "20%",
                                        }}
                                    />
                                )}
                                <div>
                                    {method.link ? (
                                        <a
                                            href={method.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="fw-bold text-primary text-decoration-none"
                                            style={{ fontSize: "18px" }}
                                        >
                                            {method.name}
                                        </a>
                                    ) : (
                                        <span
                                            className="fw-bold text-dark"
                                            style={{ fontSize: "18px" }}
                                        >
                                            {method.name}
                                        </span>
                                    )}
                                    <p className="mb-0" style={{ fontSize: '16px' }}>{method.description}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <hr style={{ height: "2px", backgroundColor: "black" }} />
                <div className=" text-center justify-content-center">
                    <Row className="align-items-center">
                        <Col xs="auto">
                            <h4 style={{ whiteSpace: 'nowrap' }}>Where does the Zakat go?</h4>
                        </Col>
                        <Col xs="auto" className="d-flex justify-content-end">
                            <Button
                                href="/WhatWeDo"
                                style={{
                                    backgroundColor: "#42226D",
                                    borderColor: "#42226D",
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Lora',
                                    width: 'auto'
                                }}
                            >
                                What We Do
                            </Button>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex justify-content-center" style={{ height: '250px', width: '100%' }}>
                    <ZakatChart className='mb-2' />
                </div>
            </Container>
            <MobileFooter />
        </div>
    );
};

export default MobilePayZakat;
